var React = require('react');

function ArrowBack (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"ic_arrow_back_24px","d":"M20,11H7.83l5.59-5.59L12,4,4,12l8,8,1.41-1.41L7.83,13H20Z","transform":"translate(-4 -4)"}));
}

ArrowBack.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = ArrowBack;

ArrowBack.default = ArrowBack;
